module.exports = {
  output: "export",
  assetPrefix: "",
  basePath: "",
  reactStrictMode: true,
  trailingSlash: true,
  images: {
    disableStaticImages: true,
  },
  productionBrowserSourceMaps: true,
  pageExtensions: ["page.js"],
  rewrites: async () => [
    {
      source: "/_sf/:path*",
      destination: `${process.env.API_URL}/_sf/:path*`,
    },
  ],
  async redirects() {
    return [
      {
        source: "/blogs/",
        destination: "/legal-blogs/",
        permanent: true, // 301
      },
      {
        source: "/blogs/:slug",
        destination: "/legal-blogs/:slug",
        permanent: true, // 301
      },
    ];
  },
  webpack: (config) => {
    config.module.rules.push({
      test: /\.svg$/,
      use: ["@svgr/webpack"],
    });
    config.module.rules.push({
      test: /\.(jpe?g|png|gif|ico|eot|ttf|woff|woff2|mp4|pdf|webm|webp)$/,
      type: "asset",
      generator: {
        filename: "static/chunks/[path][name].[hash][ext]",
      },
    });

    return config;
  },
};
